if (!customElements.get('rrd-desktop-gallery')) {
  customElements.define('rrd-desktop-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const dialog = this.querySelector('dialog');
      const zoom = this.querySelector('.rrd-desktop-gallery__zoom');
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-rrd-enlarge]');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        zoom.src = link.href;
        zoom.alt = link.querySelector('img').alt;
        dialog.showModal();
      }, options);
      dialog.querySelector('button').addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) {
          const r = dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
        }
      }, options);
      const breakpoint = matchMedia('(min-width: 1001px)');
      const sync = () => {
        const gallery = this.closest('media-gallery');
        const hiddenArea = breakpoint.matches ? gallery.querySelector('slider-component') : this;
        hiddenArea?.querySelectorAll('video').forEach(video => video.pause());
        if (!breakpoint.matches && dialog.open) dialog.close();
      };
      breakpoint.addEventListener('change', sync, options);
      sync();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}
